import React, {useEffect, useState} from 'react';
import messages from "res/messages/farsi";
import {useHistory} from "react-router-dom";
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";
import IconTitleButton from "components/buttons/IconTitleButton";
import Urls from "../../../connection/Urls";
import {Divider} from "@material-ui/core";
import EmptyBox from "components/emptyBox/EmptyBox";
import Order from "./Order";
import {groupedList} from "components/utils/ListUtility";
import Pagination from "components/list/Pagination";
import {IsLP, IsLP_MP_SP, IsLP_MP_SP_T, IsMP, IsSP} from "my-styles/media/media";
import ScrollableTitleImage from "components/imageList/ScrollableTitleImage";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import queryString from "query-string";
import {Helmet} from "react-helmet";

export default function Orders(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)
    const [isCancelled, setIsCancelled] = useState(false)
    const [orderStatusList, setOrderStatusList] = useState([])
    const [orders, setOrders] = useState([])
    const [showEmptyBox, setShowEmptyBox] = useState(false)
    const [limit] = useState(6)
    const [pages, setPages] = useState([])
    const [deleteOrderDialogShowStatus, setDeleteOrderDialogShowStatus] = useState(false)
    const [editOrderDialogShowStatus, setEditOrderDialogShowStatus] = useState(false)
    const [completeOrderDialogShowStatus, setCompleteOrderDialogShowStatus] = useState(false)
    const [currentOrder, setCurrentOrder] = useState()
    const [refreshMe, setRefreshMe] = useState(false)

    const onEdit = (order) => {
        setCurrentOrder(order)
        setEditOrderDialogShowStatus(true)
    }
    const onCancel = (order) => {
        setCurrentOrder(order)
        setDeleteOrderDialogShowStatus(true)
    }
    const onCompleteOrder = (order) => {
        setCurrentOrder(order)
        setCompleteOrderDialogShowStatus(true)
    }

    function getOrderStatus(ids) {
        let status = ids
        if (urlParams && urlParams.s && urlParams.s !== "-1") {
            status = urlParams.s
        }
        let params = new FormData()
        params.append("status", status)
        return params
    }

    function requestOrderStatus() {
        callEmptyParamsApi(Urls.getOrdersStatus, (data) => {
            if (data && data.list && data.list.length > 0) {
                setOrderStatusList(data.list)
                setShowEmptyBox(false)
                requestOrdersCount(data.list[0].ids)

            } else {
                setOrderStatusList([])
                setShowEmptyBox(true)
            }
            if (isCancelled) {
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestOrdersCount(ids) {
        let params = getOrderStatus(ids);
        callApi(Urls.getOrdersCount, params, (data) => {
            if (parseInt(data.count) === 0) {
                setShowEmptyBox(true)
            } else {
                setShowEmptyBox(false);
                let number = data.count / limit;

                if (data.count % limit > 0) {
                    number++
                }
                let tempPages = []
                for (let i = 1; i <= number; i++) {
                    tempPages.push({
                        number: i,
                        selected: i === parseInt(urlParams.p)
                    })
                }
                setPages(tempPages)
                requestGetOrders(ids);

            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestGetOrders(ids) {
        let params = getOrderStatus(ids);

        params.append("limit", limit)
        params.append("page", (urlParams && urlParams.p) ? urlParams.p : 1)
        callApi(Urls.getOrders, params, (data) => {
            if (data.list) {
                let constLimit = IsLP() ? 3 : IsMP() ? 2 : IsSP() ? 2 : 1
                let emptyCount = constLimit - (data.list.length % constLimit)
                let list = groupedList(data.list, constLimit, emptyCount)
                setOrders(list)
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestCancelOrder(order) {
        let params = new FormData()
        params.append("order_id", order.order_id)
        callApi(Urls.cancelOrder, params, () => {
            props.onAlert(messages.successCancelOrder, ALERT_TYPES.SUCCESS)
            setRefreshMe(!refreshMe)
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestEditOrder(order) {
        let params = new FormData()
        params.append("order_id", order.order_id)
        callApi(Urls.editOrder, params, () => {
            props.onNavigate(history, '/basket')
        }, (data) => {
            if (data.description === 103) {
                props.onAlert(messages.orderNotFound)
            } else if (data.description === 104) {
                props.onAlert(messages.orderCannotBeEdit)
            } else {
                props.onAlert(messages.responseCodeIsNot200)
            }
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestCompleteOrder(order) {
        let params = new FormData()
        params.append("order_id", order.order_id)
        callApi(Urls.completeOrder, params, () => {
            props.onNavigate(history, '/basket')
        }, (data) => {
            if (data.description === 103) {
                props.onAlert(messages.orderNotFound)
            } else if (data.description === 104) {
                props.onAlert(messages.orderCannotBeComplete)
            } else {
                props.onAlert(messages.responseCodeIsNot200)
            }
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function pushToHistory(s, p) {
        props.onNavigate(history, '/orders?s=' + s + "&p=" + p)
    }

    function onNumberClick(number) {
        pushToHistory(urlParams.s, number)
    }

    function onBackClick() {
        pushToHistory(urlParams.s, (parseInt(urlParams.p) - 1))
    }

    function onNextClick() {
        pushToHistory(urlParams.s, (parseInt(urlParams.p) + 1))
    }

    useEffect(() => {
        requestOrderStatus()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.search, refreshMe])

    return (<>
        {urlParams &&
        <div className={IsLP_MP_SP_T() ? "horizontalFullScreen" : ""}>
            <Helmet>
                <title>صرفه مارکت - لیست سفارشات</title>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
                <meta property="og:url" content="https://sarfemarket.ir/"/>
                <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
            </Helmet>

            {IsLP_MP_SP_T() ?
                <div className="horizontalScreen">
                <div>
                        {orderStatusList.map((orderStatus, index) => {
                            let selected = orderStatus.ids === urlParams.s
                            if (index === 0) {
                                if (urlParams.s === "-1") {
                                    selected = true
                                }
                            }
                            return (<div key={index}>
                                {(selected && index > 0) &&
                                <Divider/>
                                }
                                <IconTitleButton
                                    borderradius={"0px"}
                                    width={IsLP_MP_SP() ? "20em" : "15em"}
                                    textcolor={selected ? "var(--pink_1)" : ""}
                                    hover={selected ? "var(--pink_1)" : ""}
                                    fontSize={selected ? "mediumTextBold" : "smallTextBold"}
                                    icon={<img className="smallIcon" src={orderStatus.icon} alt=""/>}
                                    title={orderStatus.title}
                                    onClick={() => {
                                        pushToHistory(orderStatus.ids, 1)
                                    }}/>
                                {selected &&
                                <Divider/>
                                }
                            </div>)
                        })}
                    </div>
                    <div style={{minHeight: "40em", marginTop: "-15px"}}>
                        <Divider orientation={"vertical"}/>
                    </div>
                </div> :
                <div className="horizontalScreen" style={{overflow: "hidden"}}>
                    <ScrollableTitleImage
                        iconHeight={"xSmallIcon"}
                        ishorizontal={true}
                        items={
                            orderStatusList.map((orderStatus, index) => {
                                const onStatusClicked = () => {
                                    pushToHistory(orderStatus.ids, 1)
                                }
                                let selected = orderStatus.ids === urlParams.s
                                if (index === 0) {
                                    if (urlParams.s === "-1") {
                                        selected = true
                                    }
                                }
                                return {
                                    title: orderStatus.title,
                                    image: orderStatus.icon,
                                    selected: selected,
                                    onClick: onStatusClicked
                                }
                            })
                        }/>
                </div>
            }
            <div className="wInLPT100_wInFMS95 marginLeftRightSmall fullWidth">
                {showEmptyBox ?
                    <div className="marginTopBottomMedium">
                        <EmptyBox message={messages.orderListEmpty}/>
                    </div> :
                    <div>
                        {orders.map((orderGroup, index) => {
                            return (<div key={index} className="horizontalFullScreen">
                                {orderGroup.map((order, index1) => {
                                    return <Order
                                        {...props}
                                        key={index1}
                                        order={order}
                                        orderStatusId={urlParams.s}
                                        page={urlParams.p}
                                        onEdit={onEdit}
                                        onCompleteOrder={onCompleteOrder}
                                        onCancel={onCancel}/>
                                })}
                            </div>)
                        })}
                        {(orders.length > 0 && pages.length > 0) &&
                        <div style={{float: "left"}}>
                            <br/>
                            <Pagination
                                pages={pages}
                                onNumberClick={onNumberClick}
                                onNextClick={onNextClick}
                                onBackClick={onBackClick}/>
                        </div>
                        }
                    </div>
                }
            </div>
            <DialogMessage
                showStatus={deleteOrderDialogShowStatus}
                title={messages.cancelOrder}
                message={messages.sureCancelOrder}
                submitTitle={messages.yes}
                closeTitle={messages.no}
                onCloseClicked={() => {
                    setDeleteOrderDialogShowStatus(false)
                }}
                onSubmitClicked={() => {
                    setDeleteOrderDialogShowStatus(false)
                    if (currentOrder) {
                        requestCancelOrder(currentOrder)
                    }
                }}
            />
            <DialogMessage
                showStatus={editOrderDialogShowStatus}
                title={messages.editOrder}
                message={messages.sureEditOrder}
                submitTitle={messages.yes}
                closeTitle={messages.no}
                onCloseClicked={() => {
                    setEditOrderDialogShowStatus(false)
                }}
                onSubmitClicked={() => {
                    setEditOrderDialogShowStatus(false)
                    if (currentOrder) {
                        requestEditOrder(currentOrder)
                    }
                }}
            />
            <DialogMessage
                showStatus={completeOrderDialogShowStatus}
                title={messages.completeOrder}
                message={messages.sureCompleteOrder}
                submitTitle={messages.yes}
                closeTitle={messages.no}
                onCloseClicked={() => {
                    setCompleteOrderDialogShowStatus(false)
                }}
                onSubmitClicked={() => {
                    setCompleteOrderDialogShowStatus(false)
                    if (currentOrder) {
                        requestCompleteOrder(currentOrder)
                    }
                }}
            />
        </div>
        }
    </>)

}